const size = {
  mobile: "480px",
  tablet: "680px",
}

export const devices = {
  mobile: `min-width: ${size.mobile}`,
  tablet: `min-width: ${size.tablet}`,
}
